import { ChartSeries } from "models/model";

export const checkUserMinDateNotGreaterThanSeriesMax = (
  userMinDate: string | number | Date | undefined,
  series: ChartSeries[]
): string | number | Date | undefined => {
  if (!userMinDate || !series?.length) {
    return userMinDate;
  }

  // Find the maximum date in all series
  let maxSeriesDate: Date | null = null;

  series.forEach((data) => {
    data?.x?.forEach((value) => {
      const date = new Date(value);
      if (!isNaN(date.getTime()) && (!maxSeriesDate || date > maxSeriesDate)) {
        maxSeriesDate = date;
      }
    });
  });

  if (!maxSeriesDate) {
    return userMinDate;
  }

  const userDate = new Date(userMinDate);

  if (isNaN(userDate.getTime())) {
    return undefined;
  }

  // If user's min date is greater than the max date in series, return undefined to avoid freezing up chart
  // Otherwise return the user's min date
  return userDate > maxSeriesDate ? undefined : userMinDate;
};
